import { parse, stringify } from 'yaml'
import { API } from 'aws-amplify';
import Selector, { SelectorDefault } from './Selector';
import StringUtil from './StringUtil';

export interface SelectorMap {
    [key: string]: Selector;
}


export default class TemplateOptions {
    constructor(private pageType: string) {
    }

    private async getLatestTemplate(): Promise<any> {
        return await API.get('RestApi', `/config/template/${this.pageType}/latest`, {});
    }

    private getSelectorDefinitions(key: string, entry: any): any[] {
        function selectorDef(k: string, x: any): object {
            if (x instanceof Array) {
                return {key: k, values: x}
            }
            if (!(x instanceof Object)) {
               return {key: k, value: x}
            }
            return {key: k, ...x}       
        }

        if (entry && entry.type === 'nested') {
            const parent = {
                key: key, 
                values: Object.keys(entry.values),
                default: entry.default,
                type: 'multi',
                prefix: entry.prefix
            }
            const children = Object.entries(entry.values).map(
                ([k,v]) => selectorDef(`${entry.prefix} ${k}`, v));
            
            return [parent, ...children]
        }
        return [selectorDef(key, entry)]
    }

    public async getSelectors(): Promise<SelectorMap> {
        const selectors: SelectorMap = {};

        let templateInfo = await this.getLatestTemplate();
        let template = parse(templateInfo.template);
        let options = template.options;
        if (options === undefined){
            return {};
        }

        for (const key of Object.keys(options)) {
            let defs = this.getSelectorDefinitions(key, options[key]);
            for (const opt of defs) {
                let multiselect = (opt.values !== undefined && opt.type == 'multi');
                let useDefault = opt.values !== undefined
                    ? (opt.default !== undefined ? StringUtil.toEnum(SelectorDefault, opt.default) : SelectorDefault.None)
                    : (opt.value === undefined || opt.value === null ? SelectorDefault.None : SelectorDefault.First);

                selectors[opt.key] = new Selector(
                    opt.values !== undefined ? opt.values : opt.value, 
                    useDefault,
                    multiselect,
                    opt.prefix,
                    opt.required);
            }
        }

        return selectors;
    }
}
